export const opciones = {
  MANTENIMIENTO_PROVEEDORES_RECARGA: 1001, //opciones administracion
  MANTENIMIENTO_EMPLEADOS_SUPER_EMPRESAS: 1002,
  MANTENIMIENTO_EMPLEADOS_EMPRESA: 1003, // revisar
  //            REPORTE_PLANOS_VENTA :1004,
  INGRESAR_PAGO: 1005, //opciones Caja
  MANTENIMIENTO_EMPRESA: 1006,
  MANTENIMIENTO_RECAUDADORES: 1007,
  MANTENIMIENTO_VENDEDOR: 1008,
  SALDO_SUPER_EMPRESA: 1009,
  CUPO_EMPRESA: 1010,
  //            CUPO_VENDEDOR :1011,
  //            REPORTE_VENTA_RECARGAS :1012,
  //            REPORTE_TOTAL_VENTA RECARGAS :1013,
  //            REPORTE_CONSOLIDADO_RECARGAS :1014
  //            REPORTE_REPARTOS :1015,
  REPORTE_HISTORIAL_CUPO_EMPRESA: 1016,
  REPORTE_HISTORIAL_CUPO_PROVEEDOR: 1017,
  //            REPORTE_HISTORIAL_CUPO_PROMOTOR :1018,
  //            REPORTE_SALDO_MULTINIVEL :1019,
  CAMBIAR_CONTRASENA_ADMIN: 1020,
  //            CAMBIAR_CONTRASENA_VENDEDOR :1021,//VENDEDOR
  ADMINISTRACION_PERFILES: 1022, //PDTE ASIGNAR PERMISOS
  GENERAR_REGISTRO_VENTA: 1023,
  GENERAR_REGISTRO_VENTA_POR_FICHO: 1024,
  //            REPORTE_VENTAS_GENERAL:1025,
  //            INFORME_VENTAS_POR_FORMULARIO_POR_VENDEDOR :1026,
  //            REPORTE_VENTAS_BANCA_POR_VENDEDOR:1027,
  //            REPORTE_VENTAS_POR_MODALIDADES:1028,
  //            VENTA_SISTEMATIZADA_DETALLADO_VENDEDOR:1029,
  //            REPORTE_RESUMEN_GRAFICO_VENTAS:1030,
  //            REPORTE_EXTRACTO_USUARIO : 1031,
  REPORTE_EXTRACTO_USUARIO_CAJEROS: 1032,
  INFORMACION_LOTERIAS: 1033,
  INGRESAR_LOTERIA: 1034,
  MODALIDADES_LOTERIA: 1035,
  PLAN_LIQUIDACION: 1036,
  PLAN_PREMIOS_POR_MODALIDAD: 1037,
  ESCRUTAR_JUEGO_SISTEMATIZADO: 1038,
  REPORTE_GANADORES: 1039,
  REPORTE_PREMIOS: 1040,
  INGRESAR_RESULTADOS: 1041,
  INGRESAR_PAGO_PREMIOS: 1042,
  REPORTE_NUMEROS_MAS_JUGADOS: 1043,
  //            LIQUIDAR_COMISION_DE_RECARGA : 1044,
  REPORTE_VENTAS_POR_VENDEDOR: 1045,
  BLOQUEAR_NUMEROS: 1046,
  //            REPORTE_HISTORIAL_CUPO_VENDEDOR:1047,
  //            AGREGAR_USUARIO_UT:1048,
  ANULAR_BANCA: 1049,
  //            REPORTE_RECARGAS_POR_VENDEDOR:1050,
  REPORTE_VENTA_RECARGAS_POR_VENDEDOR: 1051,
  INFORME_VENTA_BANCA_RECARGAS_POR_VENDEDOR: 1052,
  REPORTE_VENTAS_BANCA_RECARGAS_POR_VENDEDOR: 1053,
  //            ASIGNACION_PLAN_PREMIOS_VENDEDOR : 1054,
  //            REPORTE_AUDITORIA_LOTERIAS: 1055,
  CONSULTAR_HORA: 1056,
  //            REPORTE_CAMBIO_PLAN_VENDEDOR: 1057,
  //            REPORTE_CAMBIOS_PLAN_LIQUIDACION: 1058,
  ESCRUTAR_JUEGO_SISTEMATIZADO_FECHA_ACTUAL: 1059,
  INGRESAR_RESULTADOS_FECHA_ACTUAL: 1060,
  REPORTE_APUESTAS_ANULADAS: 1061,
  ANULAR_PREMIOS: 1062,
  EXCEPCIONES_PLAN_PREMIOS_POR_MODALIDAD: 1063,
  ANULAR_RECARGA_VENDEDOR: 1064, //VENDEDOR
  //            ANULAR_PREMIO_VENDEDOR: 1065,//VENDEDOR
  //            REPORTE_CONEXION_PUNTO_DE VENTA : 1066,//NO
  VENTA_DE_RECARGAS: 1067, //VENDEDOR
  MENSAJERIA: 1068,
  REPORTE_NUMEROS_APOSTADOS: 1069,
  ENTREGA_EFECTIVO_A_VENDEDOR: 1070, //REPORTE_ENVIO_DE_PERDIDAS
  REGISTRO_SORTEO_EXPRESS: 1071,
  INFORME_VENTA_LOTERIAS: 1072,
  HABILITAR_APUESTA_ANULADA: 1073,
  REPORTE_APUESTAS_ACTIVADAS: 1074,
  CONFIGURACION_EMPRESA: 1075,
  ANULAR_RECARGAS: 1076,
  REPORTE_EXTRACTO_USUARIO_ADMINISTRADORES: 1077,
  DETALLE_SUCURSALES: 1078,
  GENERADOR_TOKENS_RECAUDO: 1079,
  REPORTE_ENVIO_DE_PERDIDAS: 1080, //ENTREGA_EFECTIVO_A_VENDEDOR
  MANTENIMIENTO_PUNTO_VENTA: 1081,
  HOME: 1082,
  REPORTE_BANCAS: 1083,
  CUADRE_USUARIO: 1084, //REQUERIMIENTO #8
  CAJA_USUARIO: 1085,
  MAPA_PUNTOS_EMPRESAS: 1086,
  MANTENIMIENTO_TERMINALES: 1087,
  SOLICITUD_AMPLIACION_CUPO: 1088,
  MANTENIMIENTO_ZONAS: 1090,
  REPORTE_TRANSACCIONES_PUNTO_VENTA: 1091,
  REPORTE_UTILIDAD_VENTA_RECARGA: 1092,
  TIPO_MOVIMIENTO: 1093,
  INGRESOS_EGRESOS: 1094,
  REPORTE_DETALLE_APUESTA: 1095,
  REPORTE_DISTRIBUCION_CUPO_RECARGAS_EMPRESAS: 1096,
  REPORTE_UTILIDAD_VENTA_RECARGAS_OPERADOR: 1097,
  REPORTE_INGRESOS_EGRESOS: 1098,
  REPORTE_ESTADISTICAS_POR_MODALIDAD: 1099,
  REPORTE_PORCENTAJE_VENTAS_PREMIOS_POR_LOTERIA: 1100,
  REPORTE_CUADRE_USUARIO: 1101,
  REPORTE_CUADRE_EMPRESA: 1102,
  TRASLADO_EFECTIVO_USUARIO: 1103,
  REPORTE_TICKET_PAGADOS: 1104,
  INTERFAZ_CONTABLE: 1105,
  MAPA_SEGUIMIENTO_RECAUDO: 1106,
  JORNADA_LABORAL: 1107,
  REPORTE_JORNADA_LABORAL: 1108,
  PAGOS_FACTURAS: 1109,
  REPORTE_PAGOS_FACTURAS: 1110,
  MANTENIMIENTO_CLIENTES: 1111,
  REPORTE_LOTERIA_NACIONAL: 1112,
  ANULAR_VENTA_LOT_NACIONAL: 1113,
  PRUEBA_ANGULAR: 1120,
  CLAVE_DIARIA: 1114,
  REPORTE_JUEGA_MAS_PEGA_MAS: 1115,
  REPORTE_ANULACIONES_JUEGA_MAS_PEGA_MAS: 1116,
  CONSULTAR_AGENCIA: 1117,
  REPORTE_RECARGAS_ANULADAS: 1118,
  NUMEROS_MAS_JUGADOS: 1119,
  TICKETS_ANULADOS_LOTERIA_NACIONAL: 1120,
  ADMINISTRAR_CORREOS: 1121,
  TICKETS_PAGADOS_LOTERIA_NACIONAL: 1123,
  REGISTRO_RIFA: 1126,
  REGISTRO_SORTEO: 1127,
  BOLETAS_VENDIDAS: 1128,
  BOLETAS_GANADORAS: 1129,
  BOLETAS_ANULADAS: 1130,
  REPORTE_VENTAS_QUINTE: 1133,
  REPORTE_PREMIOS_QUINTE: 1134,
  REPORTE_ANULADOS_QUINTE: 1135
};
